import { dateToday, getDate } from 'helpers/date';
import validateSpanishId from './rules/validateSpanishId';
import validateIBAN from './rules/validateIBAN';
import { validateClientAge, validateDriverLicenseAge } from './rules/validateDates';

const regexPhone = /^([9,7,6]{1})+([0-9]{8})$/;
const regexZipCode = /0[1-9][0-9]{3}|[1-4][0-9]{4}|5[0-2][0-9]{3}/;
const registrationPlateVehicle = /^[0-9]{4}[BCDFGHJKLMNPRSTVWXYZ]{3}$/;

const validators = Validator => {
  // Phone
  Validator.extend('phone', value => regexPhone.test(value) && value.length === 9);

  // Zip code
  Validator.extend('zip_code', value => regexZipCode.test(value) && value.length === 5);

  // DNI
  Validator.extend('dni', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'dni' && valid;
  });

  // NIE
  Validator.extend('nie', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'nie' && valid;
  });

  // CIF
  Validator.extend('cif', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'cif' && valid;
  });

  // Document Number (DNI or NIE)
  Validator.extend('document_number', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return (type === 'dni' || type === 'nie') && valid;
  });

  // IBAN
  Validator.extend('iban', value => validateIBAN(value));

  // Registration plate vehicles
  Validator.extend('registration_plate', value =>
    registrationPlateVehicle.test(value.toUpperCase())
  );

  // The date is today or greater in a maximum of 90 days
  Validator.extend('today_or_above_90', value => {
    const today = dateToday();
    const date = getDate(value);

    if (!date.isValid()) {
      return false;
    }

    const daysDifference = date.diff(today, 'days');
    return daysDifference >= 0 && daysDifference < 90;
  });

  // Client older between 22 - 70 years.
  Validator.extend('client_age_between', (value, ageMinMax) =>
    validateClientAge('between', value, ageMinMax)
  );

  // License equal o more 2 years.
  Validator.extend('license_age_ge', (value, args) => validateDriverLicenseAge('ge', value, args));
};

export { validators as default };
